/**
 * EmailService — Sends order notification emails via EmailJS.
 * Uses the same EmailJS service + templates as the original CDR configurator.
 */
import emailjs from '@emailjs/browser';

const EMAILJS_PUBLIC_KEY = 'user_P3AjxtpI6ITtk2g2fDLoe';
const EMAILJS_SERVICE_ID = 'service_7j4spvg';

// Templates
const TEMPLATE_ADMIN = 'template_m3o09p9';   // Notification to CDR admin
const TEMPLATE_USER = 'template_6sawex4';     // Confirmation to customer

export default class EmailService {
  constructor() {
    emailjs.init(EMAILJS_PUBLIC_KEY);
  }

  /**
   * Send order notification emails (admin + customer confirmation).
   *
   * @param {Object} params
   * @param {string} params.code - Configuration code (e.g. CDR-ABC123)
   * @param {Object} params.user - { email, name, company }
   * @param {Array} params.positions - Position array
   * @param {Object} params.formData - { kommission, notiz, offerteBis, lieferungBis }
   * @param {number} params.totalSqm - Total square meters
   */
  async sendOrderEmails({ code, user, positions, formData, totalSqm }) {
    // Build position summary for email body
    const positionsSummary = positions.map((pos, i) => {
      const variants = (pos.variants || []).map(v => {
        const sqm = ((parseFloat(v.width) || 0) * (parseFloat(v.height) || 0) / 1000000).toFixed(2);
        return `  ${v.width}×${v.height}mm, ${v.quantity} Stk, ${sqm} m²/Stk`;
      }).join('\n');
      return `Pos. ${i + 1}: ${pos.frgName || '—'} (${pos.structure})\n${variants}`;
    }).join('\n\n');

    const templateParams = {
      code,
      user_name: user.name || '—',
      user_email: user.email,
      user_company: user.company || '—',
      kommission: formData.kommission || '—',
      notiz: formData.notiz || '—',
      offerte_bis: formData.offerteBis || '—',
      lieferung_bis: formData.lieferungBis || '—',
      positions_count: positions.length,
      total_sqm: totalSqm.toFixed(2),
      positions_summary: positionsSummary,
      reply_to: user.email,
    };

    // Send admin notification
    try {
      await emailjs.send(EMAILJS_SERVICE_ID, TEMPLATE_ADMIN, templateParams);
      console.log('Admin notification email sent');
    } catch (e) {
      console.warn('Failed to send admin email:', e);
    }

    // Send customer confirmation
    try {
      await emailjs.send(EMAILJS_SERVICE_ID, TEMPLATE_USER, {
        ...templateParams,
        to_email: user.email,
      });
      console.log('Customer confirmation email sent');
    } catch (e) {
      console.warn('Failed to send customer email:', e);
    }
  }
}
